export default "__VITE_ASSET__2a220bd7__"